module.exports = __webpack_public_path__ + "fe374fbbda778cc8600ca3d2bbf49074.png";